<template>
  <div class="gestionar-producto-envasado container-fluid mt-4">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="titulo-seccion">
        <font-awesome-icon :icon="['fas', 'box-open']" class="me-2" />
        Gestionar Productos Envasados
      </h2>
    </div>

    <!-- Botonera acciones -->
    <div class="d-flex flex-wrap gap-2 mb-4 acciones" v-if="actualView === 'listar'">
      <button
        class="btn"
        :class="!mostrarSinStock ? 'btn-envasado-activo' : 'btn-outline-secondary'"
        @click="mostrarSinStock = false"
      >
        <font-awesome-icon icon="fas fa-boxes" class="me-1" />
        Con Stock
      </button>
      <button
        class="btn"
        :class="mostrarSinStock ? 'btn-envasado-activo' : 'btn-outline-secondary'"
        @click="mostrarSinStock = true"
      >
        <font-awesome-icon icon="fas fa-boxes-stacked" class="me-1" />
        Sin Stock
      </button>
    </div>

    <!-- Vista dinámica -->
    <component
      :is="actualViewComponent"
      :sinStock="mostrarSinStock"
      :producto_final_envasado_id="selectedEnvasadoId"
      :envasado="selectedEnvasado"
      @viewChange="handleViewChange"
      @cancelar="showListEnvasados"
    />

    <!-- Botón volver -->
    <div class="d-flex justify-content-end mt-4" v-if="actualView !== 'listar'">
      <button class="btn btn-light border" @click="showListEnvasados">
        <font-awesome-icon icon="fas fa-arrow-left" class="me-1" />
        Volver a Listar
      </button>
    </div>

  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ProductoFinalEnvasadoLista from '@/components/ProductoFinalEnvasado/ListarProductoFinalBulkEnvasados.vue';
import FormProductoFinalEnvasadoEditar from '@/components/ProductoFinalEnvasado/FormProductoFinalEnvasadoEditar.vue';

export default {
  name: 'GestionarProductoFinalEnvasado',
  components: {
    FontAwesomeIcon,
    ProductoFinalEnvasadoLista,
    FormProductoFinalEnvasadoEditar
  },
  data() {
    return {
      actualView: 'listar',
      mostrarSinStock: false,
      selectedEnvasadoId: null,
      selectedEnvasado: null
    };
  },
  computed: {
    actualViewComponent() {
      if (this.actualView === 'editar') return 'FormProductoFinalEnvasadoEditar';
      return 'ProductoFinalEnvasadoLista';
    }
  },
  methods: {
    showListEnvasados() {
      this.actualView = 'listar';
      this.selectedEnvasadoId = null;
      this.selectedEnvasado = null;
    },
    handleViewChange({ view, productoFinalEnvasado }) {
      this.actualView = view;
      this.selectedEnvasado = productoFinalEnvasado;
      this.selectedEnvasadoId = productoFinalEnvasado?.id || null;
    }
  }
};
</script>

<style scoped>
.gestionar-producto-envasado {
  padding: 24px;
  background-color: #f8f9fb;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.titulo-seccion {
  font-weight: 600;
  color: #5a5a89; /* color de producto envasado */
}

.acciones button {
  font-weight: 500;
}

.btn-envasado-activo {
  background-color: #5a5a89;
  color: white;
  border: none;
}

.btn-envasado-activo:hover {
  background-color: #4a4a75;
  color: white;
}

.btn-outline-secondary {
  color: #5a5a89;
  border-color: #ccc;
}

.btn-outline-secondary:hover {
  background-color: #ececf9;
  color: #393973;
}

.btn-light {
  background-color: #f8f9fa;
}

.btn-light:hover {
  background-color: #e9ecef;
}
</style>
